import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService, AuthenticationService } from '@app/_services';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.less']
})
export class HistoryComponent implements OnInit {

  constructor(private titleService: Title, private route: ActivatedRoute, private toastr: ToastrService, private _commonServices: CommonService, private AuthService: AuthenticationService) { }

  mastersuiteDetails = {};
  historyLog: any;

  ngOnInit() {
    this.route.params.subscribe((data) => {
      this.mastersuiteDetails = this.route.snapshot.data['details'].response; /* Endpoint details */
      this.AuthService.getUserRoleByProject(this.mastersuiteDetails['role']); /* Role */
      this.getHistory();
      this.titleService.setTitle('MS | ' + this.mastersuiteDetails['name']);
    });
  }

  getHistory(): void {
    const requestParams = {
      entityType: 'MASTER_SUITE',
      entityId: this.mastersuiteDetails['id'],
    };
    this._commonServices.getHistoryLog(requestParams).subscribe((data: any) => {
      if (data.code === 200) {
        data.response.forEach((value: any) => {
          value.json = JSON.parse(value.json);
        });
        this.historyLog = data.response;
      } else {
        this.toastr.error(data.message);
      }
    });
  }
}
